import LocalPedidoService from "@/services/LocalPedidoService";

export const localPedido = {
  namespaced: true,
  state: {
    localPedido: {},
  },
  actions: {
    getLocalPedido({ commit }, payload) {
      return LocalPedidoService.GetLocalPedido(payload).then(
        (localPedido) => {
          return Promise.resolve(localPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postLocalPedido({ commit }, payload) {
      return LocalPedidoService.PostLocalPedido(payload).then(
        (localPedido) => {
          return Promise.resolve(localPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putLocalPedido({ commit }, payload) {
      return LocalPedidoService.PutLocalPedido(payload).then(
        (localPedido) => {
          return Promise.resolve(localPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteLocalPedido({ commit }, payload) {
      return LocalPedidoService.DeleteLocalPedido(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getLocalPedidoOData({ commit }, payload) {
      return LocalPedidoService.GetLocalPedidoOData(payload).then(
        (localPedido) => {
          return Promise.resolve(localPedido);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default localPedido;
